"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualDistributeRewardResponseToJSON = exports.ManualDistributeRewardResponseFromJSONTyped = exports.ManualDistributeRewardResponseFromJSON = void 0;
var _1 = require("./");
function ManualDistributeRewardResponseFromJSON(json) {
    return ManualDistributeRewardResponseFromJSONTyped(json, false);
}
exports.ManualDistributeRewardResponseFromJSON = ManualDistributeRewardResponseFromJSON;
function ManualDistributeRewardResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'rewards': (json['rewards'].map(_1.RewardResponseObjectFromJSON)),
    };
}
exports.ManualDistributeRewardResponseFromJSONTyped = ManualDistributeRewardResponseFromJSONTyped;
function ManualDistributeRewardResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'rewards': (value.rewards.map(_1.RewardResponseObjectToJSON)),
    };
}
exports.ManualDistributeRewardResponseToJSON = ManualDistributeRewardResponseToJSON;
